import { IBusinessItemInfo } from 'api';
import JobTrend from 'components/shared/job-trend/JobTrend';
import React, { FC } from 'react';
import PageInfoCard from '../../PageInfoCard';
import InfoCardTitle from '../info-card-title/InfoCardTitle';

interface IProps {
  isMyRated?: boolean;
  company: IBusinessItemInfo;
}

const LeastLike: FC<IProps> = ({ company, isMyRated }) => {
  return (
    <PageInfoCard classList={company.review_count > 0 || isMyRated ? [] : ['blured']}>
      <InfoCardTitle text={`What women least like about ${company.name}`} />
      <div className={'flexWrapper'}>
        {company.least_like_top_three?.length
          ? company.least_like_top_three.map((item, index) => {
              return <JobTrend key={index} text={item} />;
            })
          : '—\t'}
      </div>
    </PageInfoCard>
  );
};

export default LeastLike;
